module.exports = {"id":"212449","name":"Mateo Pavlović","rating":"72","photo":"./data/images/photos/3/212449.png","club":{"name":"Angers SCO","logo":"./data/images/clubs/AngersSCO.png"},"positions":["DC","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MateoPavlovic0.json
// module id = 2854
// module chunks = 0